// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { userListHeaderStyles } from "@insite/content-library/Widgets/UserList/UserListHeader";
import { css } from "styled-components";

userListHeaderStyles.searchGridItem = {
    width: [12, 12, 6, 6, 6],
};
userListHeaderStyles.searchSubmitButton = {
    ...userListHeaderStyles.searchSubmitButton,
    css: css`
        flex: 0 0 auto;
        height: 47px;
        margin-top: auto;
    `,
};

userListHeaderStyles.searchTextField = {
    cssOverrides: {
        formField: css`
            flex: 1 1 auto;
            margin-right: 1rem;
        `,
        formInputWrapper: css`
            &&&& {
                input {
                    padding-right: 36px;
                }
            }
        `,
    },
    iconProps: { src: "Search" },
};